import { SideBarCard } from '@aus-platform/design-system';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Map3DSideBarContext } from 'map-3d/contexts';
import {
  selectHRA,
  selectMap3dSidebar,
  setHRATable,
} from 'map-3d/shared/map-3d-slices';
import { useContext } from 'react';
import { SidecardHeaderWithBeta } from 'src/shared/components';
import { HaulRoadAnalytics } from './haul-road-analytics';
import { HRATableCard } from './hra-table-card';

export const HRASidecard = () => {
  // Redux.
  const { table } = useAppSelector(selectHRA);
  const dispatch = useAppDispatch();

  // Hooks.
  const { activeSidebarOption } = useAppSelector(selectMap3dSidebar);

  // Contexts.
  const { hideSidecard } = useContext(Map3DSideBarContext);

  // Handlers.
  const onCloseTableCard = () => {
    dispatch(setHRATable({ ...table, show: false }));
  };

  return (
    <>
      <SideBarCard
        className="aus-sidebar-item__sidecard map-3d-sidebar-card"
        title={<SidecardHeaderWithBeta title="Haul Road Analytics" />}
        show={activeSidebarOption?.isHidden}
        onClose={hideSidecard}
      >
        <HaulRoadAnalytics />
      </SideBarCard>
      {table.show && table.haulRoadId && table.haulRoadName && (
        <HRATableCard
          isExpanded={!activeSidebarOption?.isHidden}
          onClose={onCloseTableCard}
          haulRoadId={table.haulRoadId}
          haulRoadName={table.haulRoadName}
        />
      )}
    </>
  );
};
